import { useIntl } from 'react-intl'
import Typography from '../../../../../../../Typography/Typography'
import './MenuContentImages.scss'

const WEB_PORTAL_URL = `${process.env.REACT_APP_WEB_PORTAL_URL}`

const MenuContentImages = () => {
    //TODO translate of text
    const intl = useIntl()

    return (
        <div className="menu-content-images d-flex align-items-center mx-auto">
            <a href={`${process.env.REACT_APP_WEB_PORTAL_URL}filmy`} className="menu-content-images--box d-flex">
                <img src={`images/badges/filmy.svg`} alt="filmy" />
                <Typography variant={'label'}>{intl.formatMessage({ id: 'header.menuContent.movies' })}</Typography>
            </a>
            <a
                href={`${process.env.REACT_APP_WEB_PORTAL_URL}cinestar-club`}
                className="menu-content-images--box d-flex"
            >
                <img src={`images/badges/club.svg`} alt="club" />
                <Typography variant={'label'}>
                    {intl.formatMessage({ id: 'header.menuContent.cinestarClub' })}
                </Typography>
            </a>
            <a href={`${process.env.REACT_APP_WEB_PORTAL_URL}akce`} className="menu-content-images--box d-flex">
                <img src={`images/badges/akce.svg`} alt="akce" />
                <Typography variant={'label'}>{intl.formatMessage({ id: 'header.menuContent.events' })}</Typography>
            </a>
        </div>
    )
}

export default MenuContentImages
